import React from 'react';
import { motion } from 'framer-motion';
import '../styles/fonts.css'

const menuItems = [
{ id: 'about-us', label: 'About Us' },
{ id: 'mission', label: 'Mission & Vision' },
{ id: 'process', label: 'Our Process' },
{ id: 'testimonials', label: 'Testimonials' },
{ id: 'community', label: 'Our Community' }];


export default function AboutSubmenu({ activeSection }) {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const submenuHeight = 80; // Height of sticky submenu + navbar
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - submenuHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="bg-white/80 sticky top-20 z-40 backdrop-blur-lg border-b border-gray-100 shadow-sm">
      <div className="max-w-6xl mx-auto px-6">
        <nav className="flex justify-center gap-2 md:gap-8 py-4 overflow-x-auto">
          {menuItems.map((item) =>
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className="relative px-4 py-2 text-sm md:text-base font-medium fuzzy-bubbles-bold text-gray-600 hover:text-emerald-600 transition-colors whitespace-nowrap">

              {item.label}
              {activeSection === item.id &&
            <motion.div
              layoutId="activeTab"
              className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full"
              transition={{ type: "spring", stiffness: 500, damping: 30 }} />

            }
            </button>
          )}
        </nav>
      </div>
    </div>);

}